<template>
  <div>
    <o-section :overlay="true">
      <o-text-input type="search" placeholder="Zoeken" icon="search" />
    </o-section>
    <o-section :overlay="true">
      <o-list-item
        :label="location"
        :no-padding="true"
        v-for="location in locations"
        :key="`pick${location}`"
      />
    </o-section>
  </div>
</template>

<script>
import OListItem from '@/components/base/OListItem.vue'
export default {
  name: 'OEditLocation',
  components: {
    OListItem
  },
  data: () => ({
    locations: ['Aalst', 'Berchem', 'Brussel', 'Gent', 'Kortrijk', 'Leuven']
  })
}
</script>
